import { z } from 'zod'

// Salesforce LongTextArea fields (Lead/Opportunity Closeable_Handoff_Notes__c) cap at 131072 chars.
const SALESFORCE_LONG_TEXT_AREA_MAX_LENGTH = 131072

export const closeableEventSchema = z.strictObject({
  external_client_id: z.string().min(1),
  handoff_notes: z.string().max(SALESFORCE_LONG_TEXT_AREA_MAX_LENGTH),
})

export type CreateCloseableEvent = z.infer<typeof closeableEventSchema>
export type CloseableEvent = z.infer<typeof closeableEventSchema>
